/* LA008 CRIT FIX 2026-10-31 — gate ATC until selling_plan ready; assert allocation. */
(() => {
  const PRIMARY_PRODUCT = 15413356953827;
  const VARIANT_ID = 67649125220579;
  const SELLING_PLAN = null; // UK: no selling plan
  const PRODUCT_HANDLE = 'collagen-night-wrapping-mask-1';
  const gifts = {
    single: [67657039020259],
    bogo: [67649126039779, 67628862210275, 67657039020259]
  };

  function allocation(product) {
    if (Number(product.id) !== Number(PRIMARY_PRODUCT)) throw Error('Unexpected product. Please use the product page.');
    const variant = product.variants.find(v => Number(v.id) === Number(VARIANT_ID) && v.available)
      || product.variants.find(v => v.available)
      || product.variants[0];
    if (!variant) throw Error('This offer is unavailable. Please use the product page.');
    let plan = null;
    if (SELLING_PLAN != null) {
      plan = (product.selling_plan_groups || [])
        .flatMap(g => g.selling_plans || [])
        .find(p => Number(p.id) === SELLING_PLAN);
      if (!plan) throw Error('This subscription offer is unavailable. Please use the product page.');
    }
    const price = plan
      ? ((variant.selling_plan_allocations || []).find(a => Number(a.selling_plan_id) === Number(plan.id))
          || (()=>{ throw Error('Subscription pricing is unavailable. Please refresh and try again.'); })())
      : { price: variant.price, per_delivery_price: variant.price, selling_plan_id: null };
    return { variant, plan, price };
  }

  function payload(product, tier) {
    const { variant, plan } = allocation(product);
    if (!gifts[tier]) throw Error('Choose an offer.');
    const properties = {};
    gifts[tier].forEach((id, i) => { properties[`_free gift ${i + 1}`] = String(id); });
    const main = { id: Number(variant.id), quantity: 1, properties };
    if (plan && plan.id != null) main.selling_plan = Number(plan.id);
    return {
      items: [
        main,
        ...gifts[tier].map(id => ({ id: Number(id), quantity: 1, properties: { _gift: '1' } }))
      ]
    };
  }

  if (typeof module !== 'undefined' && module.exports) {
    module.exports = { allocation, payload, SELLING_PLAN, VARIANT_ID, gifts };
    return;
  }

  const root = document.getElementById('la008');
  if (!root || root.dataset.la008Atc) return;
  root.dataset.la008Atc = 'true';

  const money = cents => new Intl.NumberFormat('en-GB', { style: 'currency', currency: 'GBP' }).format(cents / 100);
  let product;
  let offerReady = false;
  const preview = document.querySelector('[data-la008-preview-product]');

  const setTermsLoading = (msg) => {
    root.querySelectorAll('[data-recurring]').forEach(el => { el.textContent = msg; });
    root.querySelectorAll('[data-offer-price]').forEach(el => {
      if (/^Loading/i.test((el.textContent || '').trim()) || !el.textContent.trim()) {
        el.textContent = msg.startsWith('Loading') ? 'Loading…' : '—';
      }
    });
  };

  const setAtcEnabled = (enabled) => {
    root.querySelectorAll('button.la008-add, button.la008-atc').forEach(button => {
      button.disabled = !enabled;
      if (button.classList.contains('la008-atc')) {
        button.setAttribute('aria-disabled', enabled ? 'false' : 'true');
      }
    });
  };

  // Disable hero ATCs until subscription terms resolve (CRIT gate).
  setAtcEnabled(false);
  setTermsLoading('Loading subscription terms…');

  const ready = (preview
    ? Promise.resolve(JSON.parse(preview.textContent))
    : fetch('/products/' + PRODUCT_HANDLE + '.js').then(r => {
        if (!r.ok) throw Error('Could not load product.');
        return r.json();
      })
  ).then(p => {
    product = p;
    return allocation(p);
  }).then(alloc => {
    offerReady = true;
    return alloc;
  });

  const canonicalDrawer = () => {
    const drawer = document.querySelector('cart-drawer-v2#mini-cart')
      || document.querySelector('cart-drawer-v2')
      || document.querySelector('#mini-cart');
    if (!drawer) throw Error('The cart is still loading. Please try again in a moment.');
    return drawer;
  };

  async function openDrawer() {
    const drawer = canonicalDrawer();
    try {
      await Promise.race([
        customElements.whenDefined('cart-drawer-v2'),
        new Promise((_, rej) => setTimeout(() => rej(), 8000))
      ]);
    } catch (_) {}
    try {
      await fetch((window.themeVariables?.routes?.cartUrl || '/cart') + '.js', { headers: { Accept: 'application/json' } });
      document.documentElement.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true, detail: { source: 'la008-atc' } }));
      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { openMiniCart: true } }));
    } catch (_) {}
    if (typeof drawer.show === 'function') { drawer.show(); return; }
    if ('open' in drawer) { drawer.open = true; return; }
    drawer.setAttribute('open', '');
  }

  const showCart = cart => new Promise((resolve, reject) => {
    let drawer;
    try { drawer = canonicalDrawer(); } catch (e) { reject(e); return; }
    let timer;
    const finish = error => {
      clearTimeout(timer);
      observer.disconnect();
      drawer.removeEventListener('openable-element:open', opened);
      error ? reject(error) : resolve();
    };
    const opened = () => { if (drawer.hasAttribute('open') || drawer.open) finish(); };
    const observer = new MutationObserver(opened);
    observer.observe(drawer, { attributes: true, attributeFilter: ['open', 'class'] });
    drawer.addEventListener('openable-element:open', opened);
    timer = setTimeout(() => finish(Error('Your offer was added, but the cart could not open.')), 12000);
    document.documentElement.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true, detail: { cart } }));
    document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { cart, openMiniCart: true } }));
    if (typeof drawer.show === 'function') drawer.show();
    else if ('open' in drawer) drawer.open = true;
    else drawer.setAttribute('open', '');
  });

  let recoveryRequired = false, cartBusy = false;
  const refreshCart = async () => {
    const response = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
    if (!response.ok) throw Error('The cart could not refresh.');
    await showCart(await response.json());
  };

  async function readCart() {
    const response = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
    if (!response.ok) throw Error('The cart could not be read.');
    return response.json();
  }

  /** Roll back only lines this click added (from /cart/add.js response). Never clear the whole cart. */
  async function rollbackAddedLines(addResult) {
    const items = Array.isArray(addResult?.items)
      ? addResult.items
      : (addResult?.key || addResult?.id ? [addResult] : []);
    for (const item of items) {
      const key = item.key || item.id;
      if (key == null || key === '') continue;
      try {
        await fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: key, quantity: 0 })
        });
      } catch (_) {}
    }
  }

  async function assertSubscriptionCart(cart, addResult) {
    const paid = (cart.items || []).find(item =>
      Number(item.id) === Number(VARIANT_ID) && !item.properties?._gift
    ) || (cart.items || []).find(item => Number(item.id) === Number(VARIANT_ID));
    const planId = paid?.selling_plan_allocation?.selling_plan?.id;
    if (!paid) {
      try { await rollbackAddedLines(addResult); } catch (_) {}
      recoveryRequired = false;
      throw Error('Offer did not apply. Please refresh and try again.');
    }
    if (SELLING_PLAN != null && Number(planId) !== Number(SELLING_PLAN)) {
      try { await rollbackAddedLines(addResult); } catch (_) {}
      recoveryRequired = false;
      throw Error('Subscription did not apply. Please refresh and try again.');
    }
    return cart;
  }

  const unlockButtons = () => {
    if (!offerReady) return;
    root.querySelectorAll('.la008-add').forEach(button => {
      button.disabled = false;
      button.textContent = recoveryRequired ? 'Retry opening cart' : 'Add To Cart';
    });
    root.querySelectorAll('button.la008-atc').forEach(button => {
      button.disabled = false;
      button.setAttribute('aria-disabled', 'false');
    });
  };

  // Offer panels (.la008-add)
  root.querySelectorAll('.la008-commerce').forEach(panel => {
    const status = panel.querySelector('[role="status"]');
    const button = panel.querySelector('.la008-add');
    if (!button) return;
    ready.then(({ variant, price, plan }) => {
      panel.querySelectorAll('[data-offer-price]').forEach(el => { el.textContent = money(price.price); });
      const cmp = panel.querySelector('[data-compare-single]');
      if (cmp) cmp.textContent = money(Math.max(variant.price, variant.compare_at_price || 0));
      const cmp2 = panel.querySelector('[data-compare-bogo]');
      if (cmp2) cmp2.textContent = money(2 * Math.max(variant.price, variant.compare_at_price || 0));
      const rec = panel.querySelector('[data-recurring]');
      if (rec) {
        rec.textContent = `${money(price.price)} charged today, then ${money(price.per_delivery_price)} every month for the mask subscription. Offer gifts are included with this order.`;
      }
      button.disabled = false;
      setAtcEnabled(true);
    }).catch(error => {
      setTermsLoading('Subscription unavailable — refresh or use the product page.');
      if (status) status.textContent = error.message;
      button.disabled = true;
      setAtcEnabled(false);
    });

    button.addEventListener('click', async () => {
      if (button.disabled || cartBusy || !offerReady) return;
      cartBusy = true; button.disabled = true;
      if (status) status.textContent = recoveryRequired ? 'Opening your cart...' : 'Adding your offer...';
      try {
        if (recoveryRequired) {
          await refreshCart(); recoveryRequired = false;
          if (status) status.textContent = 'Cart opened. Review your items before adding another offer.';
          return;
        }
        const checked = panel.querySelector('input:checked');
        const tier = checked ? checked.value : 'bogo';
        const body = payload(product, tier);
        if (preview) {
          if (status) status.textContent = 'Local preview: offer payload validated. No cart request sent.';
          panel.dataset.qaPayload = JSON.stringify(body);
          return;
        }
        canonicalDrawer();
        recoveryRequired = true;
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify(body)
        });
        const result = await response.json();
        if (!response.ok) { recoveryRequired = false; throw Error(result.description || 'Could not add this offer. Please try again.'); }
        const cart = await assertSubscriptionCart(await readCart(), result);
        if (status) status.textContent = 'Added to your cart.';
        await showCart(cart); recoveryRequired = false;
      } catch (error) {
        if (status) status.textContent = error.message + (recoveryRequired ? ' Select Retry opening cart; this will not add the offer again.' : '');
      } finally {
        cartBusy = false; unlockButtons();
      }
    });
  });

  // TRY QUIA RISK-FREE → BOGO + selling_plan, open drawer
  async function addDefaultAndOpen(btn) {
    if (btn.dataset.busy === '1' || !offerReady) return;
    btn.dataset.busy = '1';
    btn.setAttribute('aria-busy', 'true');
    btn.disabled = true;
    try {
      await ready;
      const body = payload(product, 'bogo');
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify(body)
      });
      const result = await response.json().catch(() => ({}));
      if (!response.ok) throw new Error(result.description || result.message || 'Unable to add to cart');
      await assertSubscriptionCart(await readCart(), result);
      await openDrawer();
    } catch (err) {
      console.warn('[la008-atc]', err);
      try {
        const fd = new FormData();
        fd.append('id', String(VARIANT_ID));
        fd.append('quantity', '1');
        if (SELLING_PLAN != null) fd.append('selling_plan', String(SELLING_PLAN));
        gifts.bogo.forEach((id, i) => {
          fd.append('items[][id]', String(id));
          fd.append('items[][quantity]', '1');
          fd.append('items[][properties][_gift]', '1');
          fd.append(`properties[_free gift ${i + 1}]`, String(id));
        });
        const r = await fetch((window.Shopify?.routes?.root || '/') + 'cart/add.js', {
          method: 'POST', body: fd,
          headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/json' }
        });
        const fallbackResult = await r.json().catch(() => ({}));
        if (!r.ok) throw new Error(fallbackResult.description || fallbackResult.message || 'add failed');
        await assertSubscriptionCart(await readCart(), fallbackResult);
        await openDrawer();
      } catch (err2) {
        console.warn('[la008-atc-fallback]', err2);
        location.href = '/products/' + PRODUCT_HANDLE;
      }
    } finally {
      btn.dataset.busy = '0';
      btn.removeAttribute('aria-busy');
      unlockButtons();
    }
  }

  function bindAtc(el) {
    if (el.dataset.la008AtcBound) return;
    el.dataset.la008AtcBound = '1';
    el.classList.add('la008-atc');
    el.dataset.variantId = String(VARIANT_ID);
    if (SELLING_PLAN != null) el.dataset.sellingPlan = String(SELLING_PLAN); else delete el.dataset.sellingPlan;
    el.setAttribute('data-product-variant', String(VARIANT_ID));
    if (SELLING_PLAN != null) el.setAttribute('data-selling-plan', String(SELLING_PLAN)); else el.removeAttribute('data-selling-plan');
    el.disabled = true;
    el.setAttribute('aria-disabled', 'true');
    el.addEventListener('click', e => { e.preventDefault(); addDefaultAndOpen(el); });
  }

  for (const el of root.querySelectorAll('button.la008-atc, button[class*="la008-n"]')) {
    const label = (el.textContent || '').replace(/\s+/g, ' ').trim();
    if (/^TRY QUIA RISK-FREE$/i.test(label)) bindAtc(el);
  }
  for (const a of [...root.querySelectorAll('a[href*="collagen-night-wrapping-mask-1"], a[href="#"]')]) {
    const label = (a.textContent || '').replace(/\s+/g, ' ').trim();
    if (!/^TRY QUIA RISK-FREE$/i.test(label)) continue;
    const btn = document.createElement('button');
    btn.type = 'button';
    for (const at of [...a.attributes]) {
      if (['href', 'target', 'rel'].includes(at.name)) continue;
      btn.setAttribute(at.name, at.value);
    }
    btn.className = (a.className || '') + ' la008-atc';
    btn.innerHTML = a.innerHTML;
    a.replaceWith(btn);
    bindAtc(btn);
  }

  root.querySelectorAll('a[href="/cart"]').forEach(link => {
    link.addEventListener('click', async event => {
      event.preventDefault();
      if (cartBusy) return;
      cartBusy = true;
      try { await refreshCart(); recoveryRequired = false; }
      catch (error) { console.warn(error); }
      finally { cartBusy = false; unlockButtons(); }
    });
  });
})();
